"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearData = clearData;
const checkType_1 = __importDefault(require("./checkType"));
const defineSchema_1 = require("./defineSchema");
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * zwraca wyczyszczone dane, tylko te które są zgodne ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data dane wejściowe
 * @param {boolean} [checkDataType] czy sprawdzac poprawnośc typów danych prostych
 * (number,integer,boolean, string), domyślnie nie
 * @param {IOptions} [options] opcje, zawierające np. informacje o wyłączonych polach
 * @param {string} [currentPath=''] bieżąca ścieżka
 * @returns {*} wyczyszczone dane
 */
function clearData(schema, data, checkDataType, options = IOptions_1.defaultOptions, currentPath = '') {
    if (schema.computed) {
        return undefined;
    }
    if (schema.disabled !== undefined) {
        if (schema.disabled === true || (options && options._disabledFields && options._disabledFields.has(currentPath))) {
            return undefined;
            /*
            if (schema.type === 'array') {
              if (schema.default) {
                return Array.from(schema.default);
              } else {
                return undefined;
              }
            } else {
              return defaultValue(schema, false, null, options, currentPath);
            }
           */
        }
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        if (data === null) {
            return null;
        }
        const result = {};
        const props = schema.properties;
        if (props) {
            const path = currentPath === '' ? currentPath : currentPath + '.';
            for (const key in props) {
                const value = data[key];
                const element = props[key];
                if (value !== undefined) {
                    const nvalue = clearData(element, value, checkDataType, options, path + key);
                    if (nvalue !== undefined) {
                        result[key] = nvalue;
                    }
                }
            }
        }
        return result;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            const result = [];
            const items = schema.items;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < data.length; i++) {
                const nvalue = clearData(items, data[i], checkDataType, options, currentPath + '[' + i + ']');
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        // na razie nie sprawdzamy typów danych
        if (Array.isArray(data)) {
            return undefined;
        }
        //if (typeof data === 'object') {
        if ((0, defineSchema_1.isObject)(data)) {
            return undefined;
        }
        if (checkDataType && !(0, checkType_1.default)(schema, data)) {
            return undefined;
        }
        //puste stringi z określonymi formatami pomijaj
        if (checkDataType && data === '' && (schema.format === 'date' || schema.format === 'date-time'))
            return undefined;
        return data;
    }
}
exports.default = clearData;
//# sourceMappingURL=clearData.js.map